import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HarvestAndPlantingLegend from '../HarvestAndPlantingLegend';

function HarvestLegend(props) {
  return <HarvestAndPlantingLegend {...props} />;
}

HarvestLegend.propTypes = {
  dates: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  const activeSeason = state.seasons.activeSeasons[props.index];
  const { list } = state.seasons;
  const { harvestEndDate, harvestStartDate, harvestYear } =
    list[activeSeason.id];
  const dates = {
    endDate: harvestEndDate,
    startDate: harvestStartDate,
    year: harvestYear,
  };

  return {
    dates,
  };
}

export default connect(mapStateToProps)(HarvestLegend);
